var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "quote-success-view" },
    [
      _c(
        "div",
        { staticClass: "success-badge" },
        [
          _c("rt-picture", {
            staticClass: "icon-rocket",
            attrs: {
              src: "/assets/app/class/icon-infinite-rocket.svg",
              autosize: false,
            },
          }),
          _vm._v(" "),
          _c("rt-picture", {
            staticClass: "icon-success",
            attrs: {
              src: "/assets/app/quiz/icon-answer-passed.svg",
              autosize: false,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "success-title" }, [
        _vm._v("Request sent successfully"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "success-description" }, [
        _vm._v("We will contact you shortly!"),
      ]),
      _vm._v(" "),
      _c(
        "primary-button",
        { staticClass: "btn-close", on: { click: _vm.handleClickClose } },
        [_vm._v("Close")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }